export const REGISTRATION_REQUEST_SENT = 'REGISTRATION_REQUEST_SENT';
export const REGISTRATION_SUCCESSFUL = 'REGISTRATION_SUCCESSFUL';

export const SIGN_IN_REQUEST_SENT = 'SIGN_IN_REQUEST_SENT';
export const SIGN_IN_SUCCESSFUL = 'SIGN_IN_SUCCESSFUL';

export const SIGN_OUT_REQUEST_SENT = 'SIGN_OUT_REQUEST_SENT';
export const SIGN_OUT_SUCCESSFUL = 'SIGN_OUT_SUCCESSFUL';

export const VERIFICATION_REQUEST_SENT = 'VERIFICATION_REQUEST_SENT';
export const VERIFICATION_SUCCESSFUL = 'VERIFICATION_SUCCESSFUL';

export const ACCOUNT_UPDATE_REQUEST_SENT = 'ACCOUNT_UPDATE_REQUEST_SENT';
export const ACCOUNT_UPDATE_SUCCESSFUL = 'ACCOUNT_UPDATE_SUCCESSFUL';

export const AUTHENTICATION_ERROR = 'AUTHENTICATION_ERROR';
